import { Proposal } from '../model/types/ProposalSchema';

export const isProposalInAvailabilityCheck = (proposals: Proposal[]) => {
    if (!proposals) {
        return false;
    }

    return proposals.some((proposal) => proposal.availableQuantity === null);
};
